module.exports = __webpack_public_path__ + "static/media/c-vegeterian.90f87501.jpg";